export default {
  superAdmin: [
    {
      path: "/dashboard",
      iconStyle: imagepaths.Dashboard,
      iconActive: imagepaths.DashboardActive,
      label: "Dashboard",
    },
    {
      path: "/schoolmanagement",
      iconStyle: imagepaths.School,
      iconActive: imagepaths.SchoolActive,
      label: "School Management",
    },
    {
      path: "/invoiceform",
      iconStyle: imagepaths.InvoiceIcon,
      iconActive: imagepaths.InvoiceIconActive,
      label: "Invoice Form",
    },
    {
      path: "/masterdata",
      iconStyle: imagepaths.MasterData,
      iconActive: imagepaths.MasterDataActive,
      label: "Master Data",
      childrenIds: ["/submodules", "/deviceconfiguration", "/configureassessmentparameter", "/category", "/maintenancetracker"],
      children: [
        {
          label: "Sub Modules",
          icon: "",
          path: "/submodules",
        },
        {
          label: "Category",
          icon: "",
          path: "/category",
        },
        // {
        //   label: "Maintenance Tracker",
        //   icon: "",
        //   path: "/maintenancetracker",
        // },


        {
          label: "Configure Assessment Parameter",
          icon: "",
          path: "/configureassessmentparameter",
        },
        // {
        //   label: "Device Configuration",
        //   icon: "",
        //   path: "/deviceconfiguration",
        // },
      ],
    },
    // {
    //     path: "/classmanagement",
    //     icon: "la la-file-text",
    //     label: "Class Management",
    // },
    // {
    //   path: "/schoolinframaintenancetracker",
    //   iconStyle: imagepaths.Content,
    //   iconActive: imagepaths.ContentActive,
    //   label: "School Infra Maintenance Tracker",
    //   childrenIds: ["/schoolinframaintenancetracker/dashboard", "/schoolinframaintenancetracker/maintenancequeue"],
    //   children: [
    //     {
    //       label: "Dashboard & Reporting",
    //       icon: "",
    //       path: "/schoolinframaintenancetracker/dashboard",
    //     },
    //     {
    //       label: "Maintenance Queue",
    //       icon: "",
    //       path: "/schoolinframaintenancetracker/maintenancequeue",
    //     }
    //   ]
    // },
    {
      path: "/contentmanagement",
      iconStyle: imagepaths.Content,
      iconActive: imagepaths.ContentActive,
      label: "Content Management",
    },
    {
      path: "/businesstoconsumerconfig",
      iconStyle: imagepaths.Employee,
      iconActive: imagepaths.EmployeeActive,
      label: "B2C Package Configuration",
    },
    {
      path: "/employeemanagement",
      iconStyle: imagepaths.Employee,
      iconActive: imagepaths.EmployeeActive,
      label: "Employee Management",
    },
    // {
    //   path: "/career",
    //   iconStyle: imagepaths.Employee,
    //   iconActive: imagepaths.EmployeeActive,
    //   label: "Career",
    // },
    {
      path: "/schedulemanagement",
      iconStyle: imagepaths.ScheduleIcon,
      iconActive: imagepaths.ScheduleIconActive,
      label: "Schedule Management",
    },
    {
      path: "/taskmanagement",
      iconStyle: imagepaths.InvoiceIcon,
      iconActive: imagepaths.InvoiceIconActive,
      label: "Task Management",
    },
    {
      path: "/attendancemanagement/history",
      iconStyle: imagepaths.attendanceIcon,
      iconActive: imagepaths.attendanceIcon,
      label: "Attendance",
    },
    {
      path: "/enquires",
      iconStyle: imagepaths.EnquiryIcon,
      iconActive: imagepaths.EnquiryIconActive,
      label: "Enquires",
    },
    {
      path: "/gallerymanagement",
      iconStyle: imagepaths.GalleryIcon,
      iconActive: imagepaths.GalleryIconActive,
      label: "Gallery Management",
    },
    {
      path: "/assessmanagement",
      iconStyle: imagepaths.attendanceIcon,
      iconActive: imagepaths.attendanceIcon,
      label: "Assessment Management",
    }],
  schoolAdmin: [
    {
      path: "/dashboard",
      iconStyle: imagepaths.Dashboard,
      iconActive: imagepaths.DashboardActive,
      label: "Welcome",
    },
    {
      path: "/invoiceform",
      iconStyle: imagepaths.InvoiceIcon,
      iconActive: imagepaths.InvoiceIconActive,
      label: "Invoice Form",
    },
    {
      path: "/schoolmanagement",
      iconStyle: imagepaths.School,
      iconActive: imagepaths.SchoolActive,
      label: "School Management",
    },
    {
      path: "/assessmanagement",
      iconStyle: imagepaths.attendanceIcon,
      iconActive: imagepaths.attendanceIcon,
      label: "Assessment Management",
    }],
  schoolCoordinator: [
    {
      path: "/dashboard",
      iconStyle: imagepaths.Dashboard,
      iconActive: imagepaths.DashboardActive,
      label: "Home",
    },

    {
      path: "/contentmanagement",
      iconStyle: imagepaths.Content,
      iconActive: imagepaths.ContentActive,
      label: "Content Delivery",
    },
    {
      path: "/schooladmin/classmanagement",
      iconStyle: imagepaths.ClassManagement,
      iconActive: imagepaths.ClassManagementActive,
      label: "Class Management",
    },
    {
      path: "/schedulemanagement",
      iconStyle: imagepaths.ScheduleIcon,
      iconActive: imagepaths.ScheduleIconActive,
      label: "Schedule Management",
    },
    {
      path: "/taskmanagement",
      iconStyle: imagepaths.InvoiceIcon,
      iconActive: imagepaths.InvoiceIconActive,
      label: "Task Management",
    },
    // {
    //   path: "/schoolinframaintenancetracker",
    //   iconStyle: imagepaths.Content,
    //   iconActive: imagepaths.ContentActive,
    //   label: "School Infra Maintenance Issues Tracker",
    // },
    {
      path: "/attendancemanagement",
      iconStyle: imagepaths.attendanceIcon,
      iconActive: imagepaths.attendanceIcon,
      label: "Attendance",
      childrenIds: ["/attendancemanagement/current", "/attendancemanagement/history"],
      children: [
        {
          label: "Today’s Attendance",
          icon: "",
          path: "/attendancemanagement/current",
        },
        {
          label: "History",
          icon: "",
          path: "/attendancemanagement/history",
        }],
    },
    {
      path: "/assessmanagement",
      iconStyle: imagepaths.attendanceIcon,
      iconActive: imagepaths.attendanceIcon,
      label: "Assessment Management",
    }],
  salesOps: [
    // {
    //   path: "/schoolinframaintenancetracker",
    //   iconStyle: imagepaths.School || imagepaths.Content,
    //   iconActive: imagepaths.SchoolActive || imagepaths.ContentActive,
    //   label: "School Infra Maintenance Tracker",
    //   childrenIds: ["/schoolinframaintenancetracker/dashboard", "/schoolinframaintenancetracker/maintenancequeue"],
    //   children: [
    //     {
    //       label: "School Dashboard",
    //       icon: "",
    //       path: "/schoolinframaintenancetracker/dashboard",
    //     },
    //     {
    //       label: "Maintenance Queue",
    //       icon: "",
    //       path: "/schoolinframaintenancetracker/maintenancequeue",
    //     }
    //   ]
    // }
  ],
};
